// eslint-disable-next-line no-useless-escape
export const PHONENUMBER_REGEX: RegExp =
   /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,10}$/

export const PHONENUMBER_VN_REGEX: RegExp = /(84|0[3|5|7|8|9])+([0-9]{8})\b/

export const PASSWORD_REGEX: RegExp = /^.{6,}$/

export const SPACE_REGEX: RegExp = /[^\s-]/
